export default "__VITE_ASSET__RQ5Jgbjj__"